/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import React from "react";
import { ListItem } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const TextLink = (props) => {

    const link = props?.link;
    const style = props?.style;
    const openInNewTab = link?.is_external || link?.new_tab;

    return (
        <ListItem>
            <a
                href={link?.url}
                className={link?.is_external ? `link--icon link--icon--left ${style}` : `text-link ${style} `}
                target={openInNewTab ? "_blank" : "_self"}
                rel="noreferrer"
            >
                <span>{link?.text}</span> {link?.is_external &&
                    <FontAwesomeIcon icon={`fa-regular fa-arrow-up-right-from-square`} />
                }
            </a>
        </ListItem>
    );
};

export { TextLink };
